import 'custom-event-polyfill'; // Allow custom events to work in old versions of IE
import 'jquery-migrate';
import $ from 'jquery';
import Events from './embed/Events.js';
import { parse } from 'uri-js';
// Adding this as a global since tracker.js is not currently babelified, and it cannot import modules
window.Hubs ? Hubs.url = { parse } : window.Hubs = { url: { parse } };
import './embed/core.js';
import './shared_constants.js';
import './constants.js';
import './config.js';
import './shared_util.js';
import './util.js';
import './logger.js';
import './tracker.js';
import './embed/lazyloader.js';
import './embed/app.js';
/**
 * Since our embed app is loaded in later by our embed script, we need a hook
 * to know when its ready so we can apply custom event hooks. Since jQuery won't 
 * neccesarily be available, we need to be able to do this natively.
 */
HubsEmbed.Events = new Events('uf', window);
HubsEmbed.Events.trigger('embedLoaded', {HubsEmbed: window.HubsEmbed, $: $})
